import React from "react";
import { Controller } from "react-hook-form";
import "./element.scss";
import UploadMedia from "../../../upload-media/upload-media";
import Typography from "../../../typography/typography";


interface DynamicMediaProps {
  formControl: any;
  fieldArrayName: string;
  name: string;
  label?: string;
  defaultValue?: any;
  required?: boolean;
  disabled?: boolean;
  hidden?: boolean;
  accept?: string;
  multiple?: boolean;
  maxSize?: number;
}

const DynamicMedia = React.memo((props: DynamicMediaProps) => {

  return (
    <Controller
      control={props.formControl}
      name={`${props.fieldArrayName}.${props.name}`}
      render={({ field, fieldState: { error } }) => (
        <>
          <UploadMedia
            // {...field}
            dataPosition={props.position}
            dataName={`${props.fieldArrayName}.${props.name}`}
            label={props.label}
            required={props.formType === "builder" ? false : props.required}
            type={props.field_type}
            max_size={props?.max_size}
            disabled={props?.disabled}
            onChange={field?.onChange}
            name={props.name}
            value={field?.value || props?.value}
            multiple={Boolean(props?.is_multiple)}
            renderPreview={props?.renderPreview}
          />
          {error &&
            <Typography color="theme.error.600" type="s5">{error.message}</Typography>
          }
        </>
      )}
    />
  );
});
export { DynamicMedia };
export default DynamicMedia;
